import { render } from "./levitateLoginCard.vue?vue&type=template&id=313b9c72&scoped=true"
import script from "./levitateLoginCard.vue?vue&type=script&lang=js"
export * from "./levitateLoginCard.vue?vue&type=script&lang=js"

import "./levitateLoginCard.vue?vue&type=style&index=0&id=313b9c72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313b9c72"]])

export default __exports__